import { getDatabase, ref, set, child, get, query, orderByChild, limitToLast, update } from "./firebaseConfig";
import { getTimestampInSeconds } from "../utils/helpers"

var md5 = require('md5');

const recordPlayer = () =>{
    const db = getDatabase();
    var date = new Date();
    var day = date.getDate();
    var month = date.getMonth() + 1; // getMonth() returns a 0-based value, so we need to add 1 to get the correct month
    var dateString = month + "-" + day;

    get(child(ref(db), "records/" + dateString)).then((snapshot) => {
        if(snapshot.val()){
            const updates = {};
            updates['records/' + dateString ] = snapshot.val()+1;
            update(ref(db), updates).then(() => {
            });
        }else{
            const updates = {};
            updates['records/' + dateString ] = 1;
            update(ref(db), updates).then(() => {
            });
        }
    });
}

const registerUser = (username, emailAddress, score, onComplete, onError) => {
    const db = getDatabase();
    var score = {
        score: score,
        created_at: Date.now()
    }
    const updates = {};
    updates['players/' + md5(emailAddress) + "/scores/" + new Date().getTime()] = score;
    updates['players/' + md5(emailAddress) + "/email_address"] = emailAddress;
    updates['players/' + md5(emailAddress) + "/user_name"] = username;

    update(ref(db), updates).then(() => {
        get(child(ref(db), "scores/" + md5(emailAddress))).then((snapshot) => {
            if (snapshot.exists()) {
                if (snapshot.val().score < score.score) {
                    var newScoreUpdate = {};
                    // score["email_address"] = emailAddress;
                    score["user_name"] = username;
                    newScoreUpdate['scores/' + md5(emailAddress)] = score;
                    update(ref(db), newScoreUpdate).then(() => {
                        onComplete();
                    }).catch((err) => {
                        onError();
                    });
                }
            } else {
                var newScoreUpdate = {};
                // score["email_address"] = emailAddress;
                score["user_name"] = username;
                newScoreUpdate['scores/' + md5(emailAddress)] = score;
                update(ref(db), newScoreUpdate).then(() => {
                    onComplete();
                }).catch((err) => {
                    onError();
                });
            }
        }).catch((error) => {
            console.error(error);
            onError();
        });
    }).catch((error) => {
        console.error(error);
        onError();
    });
}


const getTopPlayers = (callbackResult) => {
    const db = getDatabase();
    var qry = query(ref(db, 'scores'), orderByChild('score'), limitToLast(8))
    get(qry).then(snapshot => {
        var data = snapshot.val();
        // Create an array to hold the ranking
        var ranking = [];

        // Loop through the data and add the ID and score to the ranking array
        for (var key in data) {
            ranking.push({
                id: key,
                score: data[key].score,
                created_at: data[key].created_at,
                user_name: data[key].user_name
            });
        }

        // Sort the ranking array by score in descending order, and then by "created_at" in ascending order
        ranking.sort(function (a, b) {
            if (b.score !== a.score) {
                return b.score - a.score;
            } else {
                return b.created_at - a.created_at;
            }
        });

        // Display the ranking
        // for (var i = 0; i < ranking.length; i++) {
        //     console.log((i + 1) + ". ID: " + ranking[i].id + " Score: " + ranking[i].score + " Created at: " + ranking[i].created_at + " username: " + ranking[i].user_name);
        // }
        callbackResult(ranking);

    });
}

const getScoreRank = (newScore, rankResult) => {

    const db = getDatabase();
    var qry = query(ref(db, 'scores'), orderByChild('score'), limitToLast(8))
    get(qry).then(snapshot => {
        var data = snapshot.val();

        // Create an array to hold the ranking
        var ranking = [];

        // Loop through the data and add the ID and score to the ranking array
        for (var key in data) {
            ranking.push({
                id: key,
                score: data[key].score,
                created_at: data[key].created_at
            });
        }

        // Add the new score to the ranking array
        ranking.push({
            id: "new",
            score: newScore,
            created_at: Date.now()
        });

        // Sort the ranking array by score in descending order, and then by "created_at" in ascending order
        ranking.sort(function (a, b) {
            if (b.score !== a.score) {
                return b.score - a.score;
            } else {
                return b.created_at - a.created_at;
            }
        });

        // Display the ranking
        for (var i = 0; i < ranking.length; i++) {
           //console.log((i + 1) + ". ID: " + ranking[i].id + " Score: " + ranking[i].score + " Created at: " + ranking[i].created_at);
        }

        // Find the rank of the new score
        for (var i = 0; i < ranking.length; i++) {
            if (ranking[i].id == "new") {
                rankResult(i + 1);
            }
        }
    });
}

export { registerUser, getTopPlayers, getScoreRank,recordPlayer };